import axios from "axios";

export const getAttachmentsForDrum = async (drumId) => {
    console.log ("getAttachmentsForDrum DrumId:", drumId);
    const response = await axios.get(`api/drums/${drumId}/attachments`);
    const result = response.data;
    return result;
}

export const postAttachment = async (attachment) => {
    console.log ("Attachment:", attachment);
    const response = await axios.post("api/attachments", attachment);
    const result = response.data;
    return result;
}

export const deleteAttachment = async (attachmentId, attachmentUrl) => {
    const response = await axios.delete(`api/attachments/${attachmentId}?imageurl=${attachmentUrl}`);
    const result = response.data;
    return result;
}